import { render, staticRenderFns } from "./GotoLabel.vue?vue&type=template&id=42f99f72&scoped=true&"
import script from "./GotoLabel.vue?vue&type=script&lang=js&"
export * from "./GotoLabel.vue?vue&type=script&lang=js&"
import style0 from "./GotoLabel.vue?vue&type=style&index=0&id=42f99f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f99f72",
  null
  
)

export default component.exports